interface Props {
    url: string;
}

export const RescueMetricsHead: React.FC<Props> = ({ url }) => {
    return <script id="rescue-metrics-script-loader" src={url} />;
};
